import React, { FC } from 'react';

import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import cn from 'classnames';

import styles from './styles.module.scss';
import { useMediaQuery } from 'hooks/useMediaQuery';

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
type Props = {
  url: string;
}

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
const Video: FC<Props> = ({ url }: Props) => {
  const isMobileView = useMediaQuery(575);
  return (
    <LiteYouTubeEmbed
      poster={isMobileView ? 'default' : 'hqdefault'}
      webp
      id={url}
      title="video"
      playerClass={cn('lty-playbtn', styles.button)}
    />
  );
};

export default Video;
